export const dictionaries = {
    es: {
        auth: {
            activeAuth: "Autenticacion activa",
            auth: "Auth",
            closeSession: "Cerrar sesion",
            cognito: "Cognito",
            config: "Configuracion",
            configMissing: "Falta configurar Cognito",
            configMissingDetail: "Define REACT_APP_COGNITO_DOMAIN y REACT_APP_COGNITO_CLIENT_ID.",
            copy: "Copiar",
            copied: "Copiado",
            environment: "Environment",
            login: "Iniciar sesion",
            loginFailed: "No se pudo iniciar sesion.",
            noToken: "Sin token",
            privateDocs: "Documentacion privada",
            privateDocsDetail: "Accede con Cognito para consultar la documentacion y probar los servicios autorizados.",
            protectedSession: "Sesion protegida",
            protectedSessionDetail: "El acceso usa token temporal y vence automaticamente.",
            retry: "Reintentar",
            sandboxExpired: "El acceso del sandbox ha expirado. Cerraremos tu sesion para que ingreses nuevamente.",
            sandboxPrivate: "Sandbox privado",
            sessionValidationFailed: "No se pudo validar tu sesion. Inicia sesion nuevamente.",
            tokenActive: "Token activo",
            validatingSession: "Validando sesion",
        },
        contract: {
            auth: "Autenticacion",
            contractTable: "Endpoints del contrato",
            endpoints: "Endpoints",
            fallbackDescription: "Sin descripcion",
            fetchError: "No se pudo cargar el contrato.",
            fetchStatusError: "No se pudo cargar el contrato ({status}).",
            interactiveSwagger: "Swagger interactivo",
            loading: "Cargando contrato OpenAPI...",
            method: "Metodo",
            noSchemas: "No hay esquemas declarados.",
            notSpecified: "No especificado",
            object: "objeto",
            openApiContract: "Contrato OpenAPI",
            openApiJson: "OpenAPI (JSON)",
            path: "Ruta",
            return: "Regresar",
            schemas: "Esquemas",
            summary: "Resumen",
            tryItOut: "Probar",
            version: "Version",
        },
        documentation: {
            nativeSdks: {
                description: "Documentacion tecnica para integrar los SDK nativos del sandbox.",
                name: "SDK nativos",
                shortName: "SDK nativos",
            },
        },
        home: {
            availableContracts: "Contratos disponibles",
            availableInSandbox: "Disponibles en sandbox",
            contracts: "Contratos",
            contractsAndDocs: "Contratos y documentacion",
            deliverables: "Entregables",
            documentation: "Documentacion",
            docsSubtitle: "Consulta los contratos OpenAPI publicados, valida autenticacion y accede a las pruebas autorizadas del sandbox.",
            docsTitle: "Documentacion de servicios",
            json: "JSON",
            openApi: "OpenAPI",
            openApiPublished: "OpenAPI publicados",
            openDocumentation: "Abrir documentacion",
            portalCognito: "Portal Cognito",
            resource: "recurso",
            sdkDocumentation: "Documentacion de SDK",
            services: "Servicios",
            versionedContracts: "Contratos versionados",
            viewSwagger: "Ver Swagger",
        },
        language: {
            en: "EN",
            es: "ES",
            label: "Idioma",
        },
        layout: {
            closeNav: "Cerrar navegacion",
            contractsOpenApi: "Contratos OpenAPI",
            documentation: "Documentacion",
            openNav: "Abrir navegacion",
            services: "Servicios",
        },
        middlewareQr: {
            access: "Acceso al middleware",
            close: "Cerrar modal",
            imageAlt: "Codigo QR para abrir el middleware",
            instructions: "Escanea el QR desde tu telefono o abre la experiencia en el navegador.",
            viewWeb: "Ver web",
        },
        services: {
            commonFaceModels: {
                description: "Modelos de reconocimiento facial para calidad de imagen, embeddings y comparacion.",
                name: "Modelos de reconocimiento facial",
                shortName: "Modelos faciales",
            },
            kycSdkStorage: {
                description: "Almacenamiento y consulta de resultados generados por el SDK KYC.",
                name: "KYC SDK Storage",
                shortName: "KYC SDK Storage",
            },
            token: {
                description: "Generacion del access_token usado como Authorization Bearer en los endpoints del sandbox.",
                name: "Generador de token de acceso",
                shortName: "Token de acceso",
                tokenBadge: "Token de acceso",
            },
            listaNominal: {
                description: "Validacion de INE en lista nominal.",
                name: "Lista Nominal",
                shortName: "Lista Nominal",
            },
            middlewareUi: {
                actionLabel: "Abrir servicio",
                description: "Demo web para consumir el flujo de onboarding y biometria.",
                name: "Middleware UI",
                shortName: "Middleware UI",
            },
            nom151: {
                description: "Generacion de constancias NOM151 para flujos fintech.",
                name: "NOM151 / Fintech Pagos Middleware",
                shortName: "NOM151",
            },
            renapo: {
                description: "Validacion de CURP contra RENAPO.",
                name: "RENAPO",
                shortName: "RENAPO",
            },
        },
    },
    en: {
        auth: {
            activeAuth: "Active authentication",
            auth: "Auth",
            closeSession: "Sign out",
            cognito: "Cognito",
            config: "Configuration",
            configMissing: "Cognito is not configured",
            configMissingDetail: "Set REACT_APP_COGNITO_DOMAIN and REACT_APP_COGNITO_CLIENT_ID.",
            copy: "Copy",
            copied: "Copied",
            environment: "Environment",
            login: "Sign in",
            loginFailed: "Could not sign in.",
            noToken: "No token",
            privateDocs: "Private documentation",
            privateDocsDetail: "Sign in with Cognito to view documentation and test authorized services.",
            protectedSession: "Protected session",
            protectedSessionDetail: "Access uses a temporary token and expires automatically.",
            retry: "Retry",
            sandboxExpired: "Sandbox access has expired. We will sign you out so you can sign in again.",
            sandboxPrivate: "Private sandbox",
            sessionValidationFailed: "Could not validate your session. Sign in again.",
            tokenActive: "Active token",
            validatingSession: "Validating session",
        },
        contract: {
            auth: "Auth",
            contractTable: "Contract endpoints",
            endpoints: "Endpoints",
            fallbackDescription: "No description",
            fetchError: "Could not load the contract.",
            fetchStatusError: "Could not load the contract ({status}).",
            interactiveSwagger: "Interactive Swagger",
            loading: "Loading OpenAPI contract...",
            method: "Method",
            noSchemas: "No schemas declared.",
            notSpecified: "Not specified",
            object: "object",
            openApiContract: "OpenAPI contract",
            openApiJson: "OpenAPI (JSON)",
            path: "Path",
            return: "Back",
            schemas: "Schemas",
            summary: "Summary",
            tryItOut: "Try it out",
            version: "Version",
        },
        documentation: {
            nativeSdks: {
                description: "Technical documentation for integrating the sandbox native SDKs.",
                name: "Native SDKs",
                shortName: "Native SDKs",
            },
        },
        home: {
            availableContracts: "Available contracts",
            availableInSandbox: "Available in sandbox",
            contracts: "Contracts",
            contractsAndDocs: "Contracts and documentation",
            deliverables: "Deliverables",
            documentation: "Documentation",
            docsSubtitle: "Review published OpenAPI contracts, validate authentication, and access authorized sandbox tests.",
            docsTitle: "Service documentation",
            json: "JSON",
            openApi: "OpenAPI",
            openApiPublished: "Published OpenAPI",
            openDocumentation: "Open documentation",
            portalCognito: "Cognito portal",
            resource: "resource",
            sdkDocumentation: "SDK documentation",
            services: "Services",
            versionedContracts: "Versioned contracts",
            viewSwagger: "View Swagger",
        },
        language: {
            en: "EN",
            es: "ES",
            label: "Language",
        },
        layout: {
            closeNav: "Close navigation",
            contractsOpenApi: "OpenAPI contracts",
            documentation: "Documentation",
            openNav: "Open navigation",
            services: "Services",
        },
        middlewareQr: {
            access: "Middleware access",
            close: "Close modal",
            imageAlt: "QR code to open the middleware",
            instructions: "Scan the QR from your phone or open the experience in the browser.",
            viewWeb: "View web",
        },
        services: {
            commonFaceModels: {
                description: "Face recognition models for image quality, embeddings, and comparison.",
                name: "Face Recognition Models",
                shortName: "Face Models",
            },
            kycSdkStorage: {
                description: "Storage and lookup of results generated by the KYC SDK.",
                name: "KYC SDK Storage",
                shortName: "KYC SDK Storage",
            },
            token: {
                description: "Access token generation for the Authorization Bearer header used by the sandbox endpoints.",
                name: "Access Token Generator",
                shortName: "Access Token",
                tokenBadge: "Access token",
            },
            listaNominal: {
                description: "INE validation against the nominal list.",
                name: "Nominal List",
                shortName: "Nominal List",
            },
            middlewareUi: {
                actionLabel: "Open service",
                description: "Web demo for onboarding and biometrics flows.",
                name: "Middleware UI",
                shortName: "Middleware UI",
            },
            nom151: {
                description: "NOM151 certificate generation for fintech flows.",
                name: "NOM151 / Fintech Payments Middleware",
                shortName: "NOM151",
            },
            renapo: {
                description: "CURP validation against RENAPO.",
                name: "RENAPO",
                shortName: "RENAPO",
            },
        },
    },
};
